module.exports = __webpack_public_path__ + "media/images/txt_foryou-33e13ff3cf3d699fb7449bb42f5df998.svg";